import { Link, TableCell } from '@mui/material';
import React from 'react';
import FileUploadService from '../../services/uploadService/UploadService';
import { AppDataContext } from '../../context/Context';

export default class GridUploadCell extends React.Component {
    static contextType = AppDataContext;
    constructor(props) {
        super(props);
        this.fileService = new FileUploadService(
            this.props.context.getState().server
        );
    }

    handleOpenFile = async (file) => {
        let uuid = file.uuid;
        if (!uuid) {
            uuid = this.getUuidFromName(file.name);
        }
        try {
            await this.fileService.downloadFile(uuid);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    };
    // temp, not used
    getUuidFromName(name) {
        //                 "name": "appeal/cedcbc70-7877-474c-b14b-526906720b84.docx",
        if (!name) return null;
        const parts = name.split('/');
        if (parts.length !== 2) return null;
        const filename = parts[1];
        const uuid = filename.split('.')[0];
        return uuid;
    }

    render() {
        const file = this.props.value;
        const { id } = this.props.field;
        if (!file) {
            return <TableCell align="left">-</TableCell>;
        }
        return (
            <TableCell align="left" key={id}>
                <Link
                    component="button"
                    underline="hover"
                    onClick={() => {
                        this.handleOpenFile(file);
                    }}
                >
                    {file.name}
                </Link>
            </TableCell>
        );
    }
}
